'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var SectionHeader = function SectionHeader(props) {
	var titleProps = {};

	if (!props.alwaysOpen) {
		titleProps.onClick = props.onClick;
		titleProps.style = { cursor: 'pointer' };
	}

	return _react2['default'].createElement(
		'div',
		{ className: (0, _classnames2['default'])('SectionHeader'), id: props.id },
		_react2['default'].createElement(
			'h2',
			{
				className: (0, _classnames2['default'])('SectionTitle', {
					'SectionTitle-alwaysOpen': props.alwaysOpen
				})
			},
			!props.alwaysOpen && _react2['default'].createElement('button', {
				className: (0, _classnames2['default'])('SectionCollapseIcon', {
					'SectionCollapseIcon-open': props.isOpen
				}),
				onClick: props.onClick
			}),
			_react2['default'].createElement(
				'span',
				titleProps,
				props.title
			)
		),
		props.children
	);
};

SectionHeader.propTypes = {
	alwaysOpen: _propTypes2['default'].bool,
	id: _propTypes2['default'].string,
	isOpen: _propTypes2['default'].bool,
	onClick: _propTypes2['default'].func,
	title: _propTypes2['default'].string
};

module.exports = SectionHeader;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/SectionHeader.js
// module id = 330
// module chunks = 0